import { useContext } from "react";
import AudiolabContext from "./AudiolabContext";
import type {
  AudiolabContextType,
  TrackUploadContextFields,
} from "./AudiolabContext";

export function useAudiolab(): Pick<
  AudiolabContextType,
  | "selectedCreator"
  | "setSelectedCreator"
  | "allCreators"
  | "defaultCreator"
  | "isReadOnly"
  | "viewAllArtists"
> {
  const context = useContext(AudiolabContext);
  if (context === undefined) {
    throw new Error("useAudiolab must be used within an AudiolabProvider");
  }
  const {
    selectedCreator,
    setSelectedCreator,
    allCreators,
    defaultCreator,
    isReadOnly,
    viewAllArtists,
  } = context;
  return {
    selectedCreator,
    setSelectedCreator,
    allCreators,
    defaultCreator,
    isReadOnly,
    viewAllArtists,
  };
}

export function useTrackUpload(): TrackUploadContextFields {
  const context = useContext(AudiolabContext);
  if (context === undefined) {
    throw new Error("useTrackUpload must be used within an AudiolabProvider");
  }
  const {
    isUploading,
    errorMessage,
    uploadQueue,
    processingTracks,
    removeTrack,
    clearFinished,
    setShowUpload,
    openUploadForCreator,
    openUploadForRelease,
    lockedUploadCreatorId,
    openUploadForMastering,
    uploadMasteringPreset,
    uploadMaxFiles,
    handleFilesSelect,
    createTracks,
  } = context;
  return {
    isUploading,
    errorMessage,
    uploadQueue,
    processingTracks,
    removeTrack,
    clearFinished,
    setShowUpload,
    openUploadForCreator,
    openUploadForRelease,
    lockedUploadCreatorId,
    openUploadForMastering,
    uploadMasteringPreset,
    uploadMaxFiles,
    handleFilesSelect,
    createTracks,
  };
}
